export default __webpack_public_path__ + "static/media/sticker-e.bc034f9b.png";